import https from "./https";
import store from "@/store";

const branch = {
  getBranches(organization, params) {
    const searchParams = new URLSearchParams(params);
    return https.get(
      `admin/organizations/${organization.id}/branches?${searchParams}`
    );
  },
  getMyBranches() {
    return https.get("admin/me/branches");
  },
  setCurrentBranch(branchId) {
    return https.put("admin/me/set-current-branch", {
      branch_id: branchId,
    });
  },
  createBranch(organization, params) {
    return https.post("admin/organizations/" + organization.id + "/branches", {
      ...params,
    });
  },
  updateBranch(branchID, params) {
    return https.put(`/admin/branches/${branchID}`, {
      ...params,
    });
  },
  updateBranchImages(branchId, images) {
    return https.patch(`/admin/branches/${branchId}/update-images`, {
      images
    });
  },
  getBranch(branchID) {
    return https.get(`admin/branches/${branchID}`);
  },
  getBranchStats(organization, params) {
    return https.get(`admin/organizations/` + organization.id + `/branches/statistics`, {params});
  },
  deleteBranch(branchID) {
    return https.delete(`/admin/branches/${branchID}`);
  },
  getCurrentBelowBranches(params) {
    return https.get("admin/me/current-below-branches", {params});
  },
  import(formData) {
    const organization = store.state.general.organization;

    return https.post(
      `/admin/organizations/${organization.id}/branches/import`,
      formData
    );
  },
  importStaff(branchID, formData) {
    return https.post(
      `/admin/branches/${branchID}/import-staff`,
      formData
    );
  },
  getBranchCustomers(branchID, params) {
    return https.get(`admin/branches/${branchID}/customers`, {params});
  },
  getBranchStaffs(branchID, params) {
    return https.get(`admin/branches/${branchID}/all-staffs`, {params});
  },
  getManagedStaffs(branchID, params) {
    return https.get(`admin/branches/${branchID}/staffs/managed`, {params});
  },
  getBranchOptions(organization, params) {
    const searchParams = new URLSearchParams(params);
    return https.get(
      `admin/organizations/${organization.id}/branch-options?${searchParams}`
    );
  },
  generateTwBranches(branchID, params) {
    return https.post(`admin/branches/${branchID}/generate-tw-branch`, { params });
  },
  changeBranchEnabled(branchID, params) {
    return https.post(`admin/branches/${branchID}/change-all-branches-enabled`, {
      ...params,
    });
  },
  exportBranches(organization, params) {
    const searchParams = new URLSearchParams(params);
    return https.get(
      `admin/organizations/${organization.id}/branches/export?${searchParams}`
    );
  },
  exportBranchesWithUrl(organization, params) {
    const searchParams = new URLSearchParams(params);
    return https.get(
      `admin/organizations/${organization.id}/branches/export/url?${searchParams}`
    );
  },
  exportBranchesQrCodes(organization, params) {
    const searchParams = new URLSearchParams(params);
    return https.get(
      `admin/organizations/${organization.id}/branches/export/qrcodes?${searchParams}`
    );
  },
  exportBranchesOaQrCodes(organization, params) {
    const searchParams = new URLSearchParams(params);
    return https.get(
      `admin/organizations/${organization.id}/branches/export/oa-qrcodes?${searchParams}`
    );
  },
  getBranchMenuConfig(branchID) {
    return https.get(`/admin/branches/${branchID}/menu-config`);
  },
  updateBranchMenuConfig(branchID, config) {
    return https.put(`/admin/branches/${branchID}/menu-config`, config);
  },
  updateBranchServiceConfig(branchID, service) {
    // service is simply an array of service strings.
    return https.put(`/admin/branches/${branchID}/service-config`, service);
  }
};

export default branch;
